"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rules = void 0;
const crypto_1 = require("crypto");
let getRuleJson = () => {
    let ruleJson = constructRuleset({
        name: 'EFFUnexpectedStationary',
        type: 'EffluentTracker',
        keyAttribute: 'unexpectedStationary',
        value: 1,
        count: 1,
    });
    return ruleJson;
};
const constructRuleset = (parameters) => {
    let { name, type, keyAttribute, value, count } = parameters;
    let RuleId = (0, crypto_1.randomUUID)();
    let MetricId = (0, crypto_1.randomUUID)();
    let ruleJson = {
        pk: `Ruleset:${RuleId}`,
        sk: `Ruleset:${RuleId}`,
        appliesToType: `${type}`,
        definition: {
            GeofenceRule: [],
            MetricRule: [
                {
                    pk: `MetricRule:${MetricId}`,
                    sk: `MetricRule:${MetricId}`,
                    enabled: true,
                    failMessage: ['failed message'],
                    id: '0',
                    max: {
                        datapoints: count,
                        value: value,
                    },
                    min: {
                        datapoints: 0,
                        value: 0,
                    },
                    name: 'new Metric Rule',
                    stdDev: {
                        datapoints: 0,
                        value: 0,
                    },
                    type: 'MetricRule',
                    _key: `${keyAttribute}`,
                },
            ],
        },
        globallyApplyToObjectTypeId: true,
        id: `${RuleId}`,
        name: `${name}`,
        possibleAppliesToTypes: [`${type}`],
        rulesetContent: 'METRIC',
        type: 'Ruleset',
    };
    return ruleJson;
};
exports.rules = {
    Ruleset: {
        names: [],
        itemProducers: [async () => [getRuleJson()]],
    },
};
